/* eslint-disable
    eqeqeq,
*/

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';
import { Auth } from 'app/scripts/db/auth';
import { dontUpsell } from '@trello/browser';
import { clientVersion } from '@trello/config';
import { featureFlagClient } from '@trello/feature-flag-client';
import { BUTLER_POWER_UP_ID } from 'app/scripts/data/butler-id';
import { makeErrorEnum } from 'app/scripts/lib/make-error-enum';
import { ModelCache } from 'app/scripts/db/model-cache';
import { ModelLoader } from 'app/scripts/db/model-loader';
import { Plugin } from 'app/scripts/models/Plugin';
import { PluginIO } from 'app/scripts/views/internal/plugins/PluginIo';
import { pluginIOCache } from 'app/scripts/views/internal/plugins/PluginIoCache';
import {
  serialize,
  extend,
} from 'app/scripts/views/internal/plugins/PluginHandlerContext';
import { PluginOptions as pluginOptions } from 'app/scripts/views/internal/plugins/PluginOptions';
import pluginValidators from 'app/scripts/lib/plugins/plugin-validators';
import { PluginProcessCallbacks as processCallbacks } from 'app/scripts/views/internal/plugins/PluginProcessCallbacks';
import Promise from 'bluebird';
import xtend from 'xtend';

const PluginRunnerError = makeErrorEnum('PluginRunner', [
  'NotHandled',
  'InvalidPlugin',
  'Timeout',
]);

const DEFAULT_TIMEOUT = 5000;

const eventualEnabledPlugins = {};

const loadAvailablePlugins = function (idBoard) {
  // We might have several PluginRunners make requests at once (e.g. for badges)
  // and we don't want all of them to trigger duplicate requests to loading the
  // plugins from the server.
  if (eventualEnabledPlugins[idBoard] == null) {
    eventualEnabledPlugins[idBoard] = ModelLoader.loadBoardEnabledPlugins(
      idBoard,
    );

    eventualEnabledPlugins[idBoard].then(
      () => delete eventualEnabledPlugins[idBoard],
    );
  }

  return eventualEnabledPlugins[idBoard];
};

const loadPlugin = (board, pluginOrId) =>
  Promise.try(function () {
    let existingPlugin;
    if (pluginOrId instanceof Plugin) {
      return pluginOrId;
    }

    if (!_.isString(pluginOrId)) {
      throw PluginRunnerError.InvalidPlugin('invalid plugin specifier');
    }

    const idPlugin = pluginOrId;
    if ((existingPlugin = ModelCache.get('Plugin', idPlugin)) != null) {
      return existingPlugin;
    }

    if (board == null) {
      throw PluginRunnerError.InvalidPlugin('unable to find plugin');
    }

    return loadAvailablePlugins(board.id).then(function () {
      if ((existingPlugin = ModelCache.get('Plugin', idPlugin)) != null) {
        return existingPlugin;
      }

      throw PluginRunnerError.InvalidPlugin('plugin not available to board');
    });
  });

const extractPlugins = function ({ plugins, plugin, board }) {
  plugins =
    plugins ??
    (plugin != null ? [plugin] : undefined) ??
    board?.idPluginsEnabled() ??
    [];

  return Promise.map(plugins, (pluginOrId) => {
    return loadPlugin(board, pluginOrId);
  });
};

const extractCommonContext = function (options) {
  let idOrg, org;
  const board = options?.board;
  const baseContext = {
    version: /^build-\d+$/.test(clientVersion) ? clientVersion : 'unknown',
    member: Auth.me(),
    permissions: {
      board: board?.editable() ? 'write' : 'read',
    },
  };
  if ((idOrg = board?.hasOrganization()) != null) {
    baseContext.organization = idOrg;
  }
  if ((org = board?.getOrganization()) != null) {
    baseContext.permissions.organization = org?.hasActiveMembership(Auth.me())
      ? 'write'
      : 'read';
  }
  if (board?.isEnterpriseBoard() && board.getEnterprise()) {
    baseContext.enterprise = board.getEnterprise().id;
  }
  if (options.card != null) {
    baseContext.permissions.card = options.card.editable() ? 'write' : 'read';
  }
  const extendedContext = ['board', 'list', 'card', 'command', 'el'];
  return xtend(baseContext, _.pick(options, extendedContext));
};

const extractCommandOptions = ({ options }) => options;

const returnFirstOrError = function (responses, command) {
  if (responses.length === 0) {
    throw PluginRunnerError.NotHandled('no plugin handles this command', {
      command,
    });
  }
  return _.first(responses);
};

const validateUrls = (obj, idPlugin) =>
  _.each(obj, function (val, key) {
    if (_.isObject(val) || _.isArray(val)) {
      return validateUrls(val, idPlugin);
    } else if (key === 'url' && !pluginValidators.isValidUrlForImage(val)) {
      if (typeof console !== 'undefined' && console !== null) {
        console.warn(
          `Invalid URL detected in Power-Up response for: ${idPlugin}`,
        );
      }
      throw new PluginIO.Error.NotHandled('Invalid url');
    }
  });
class PluginRunner {
  static initClass() {
    this.prototype.Error = PluginRunnerError;
  }
  processCallbacks(obj, pluginEntry, baseOptions) {
    return processCallbacks(obj, (runOptions) => {
      const options = xtend(baseOptions, runOptions);
      const runAction = runOptions.options.action;
      return this._run(
        [pluginEntry],
        extractCommonContext(options),
        extractCommandOptions(options),
      )
        .then(returnFirstOrError)
        .catch(PluginRunnerError.NotHandled, function (err) {
          throw PluginRunnerError.NotHandled(
            `attempt to ${runAction} callback on plugin ${pluginEntry.plugin.id} failed`,
          );
        });
    });
  }

  _getPluginSpecificContext(idPlugin, board) {
    switch (idPlugin) {
      case BUTLER_POWER_UP_ID:
        // Allow Butler to know if we are in a Desktop context
        // As Butler will have to hide upsells to conform to app store rules
        return {
          dontUpsell: dontUpsell(),
          canShowButlerUI: board.canShowButlerUI(),
          useRoutes: true,
          butlerName: 'automation',
          sendBreadcrumbs: featureFlagClient.get(
            'workflowers.butler-client-breadcrumbs',
            false,
          ),
          butlerkey: 'automation',
          useNewButton: true,
          showUsageTab: featureFlagClient.get(
            'workflowers.show-usage-tab',
            false,
          ),
          // Deprecated FFs; to be cleaned up in Butler Client separately
          omitCardButtons: true,
          ungatePaidCommands: true,
        };
      default:
        return {};
    }
  }

  _run(pluginEntries, commonContext, commandOptions, timeout) {
    if (timeout == null) {
      timeout = DEFAULT_TIMEOUT;
    }
    const { command, board, card, member } = commonContext;

    return Promise.using(
      serialize(commonContext),
      (serializedCommonContext) => {
        return Promise.filter(pluginEntries, ({ io }) => io.supports(command))
          .map((pluginEntry) => {
            const { plugin, io } = pluginEntry;

            const pluginSpecificContext = this._getPluginSpecificContext(
              plugin.id,
              board,
            );
            const commandOptionsWithContext = xtend(commandOptions, {
              context: extend(serializedCommonContext, pluginSpecificContext),
            });

            return io
              .request(
                command,
                pluginOptions(commandOptionsWithContext),
                timeout,
              )
              .then((response) => {
                validateUrls(response, plugin.id);
                return {
                  response: this.processCallbacks(response, pluginEntry, {
                    board,
                    card,
                    member,
                  }),
                  idPlugin: plugin.id,
                };
              })
              .catch(
                PluginIO.Error.NotHandled,
                PluginIO.Error.Timeout,
                () => null,
              );
          })
          .filter((entry) => entry != null)
          .map(function ({ response, idPlugin }) {
            if (
              Array.isArray(response) &&
              _.compact(response).every(_.isObject)
            ) {
              return _.compact(response).map((r) => xtend(r, { idPlugin }));
            } else if (_.isObject(response)) {
              return xtend(response, { idPlugin });
            } else {
              return response;
            }
          });
      },
    );
  }

  _runFromOptions(options) {
    const plugins = extractPlugins(options);
    const commonContext = extractCommonContext(options);
    const commandOptions = extractCommandOptions(options);

    return Promise.resolve(plugins)
      .filter((plugin) =>
        options.fxPluginFilter ? options.fxPluginFilter(plugin) : true,
      )
      .map((plugin) => ({
        plugin,
        io: pluginIOCache.get(plugin),
      }))
      .then((pluginEntries) => {
        return this._run(
          pluginEntries,
          commonContext,
          commandOptions,
          options.timeout,
        );
      });
  }

  all(options) {
    return this._runFromOptions(options).then(_.flatten);
  }

  one(options) {
    return this._runFromOptions(options).then((response) => {
      return returnFirstOrError(response, options.command);
    });
  }

  getOrLoadPlugin(board, idPlugin) {
    return loadPlugin(board, idPlugin);
  }
}
PluginRunner.initClass();
const pluginRunner = new PluginRunner();

export { pluginRunner };
